import { Text } from '@pairy/pds-react';
import Image from 'next/image';

import handleFreeBadgeLinkOpen from '../../../../utils/handleFreeBadgeLinkOpen';

import * as Styled from './index.styles';

interface Props {
  userSubscriptionPlan: string;
  y?: number;
}

const MobileFreeBadge = ({ userSubscriptionPlan, y = 0 }: Props) => {
  const isFreeBadgeVisible = () => {
    return userSubscriptionPlan === 'Free';
  };

  return (
    <Styled.Container
      gap={8}
      padding={{ x: 16, y: 12 }}
      className={isFreeBadgeVisible() ? 'is-visible' : ''}
      alignItems="center"
      width="fit-content"
      style={{ transform: `scale(1.2) translate(8px, ${y}px)` }}
      onClick={() => {
        handleFreeBadgeLinkOpen();
      }}
    >
      <Text variant="sm-semibold" color="skyblue_100">
        Powered by
      </Text>
      <Image
        src="/images/salesclue_logo_black_mono.png"
        width={75}
        height={17}
        alt={'SalesClue'}
        unoptimized
      />
    </Styled.Container>
  );
};

export default MobileFreeBadge;
